/* Open Road · Quote modal
   Vanilla, no deps. Controls .or-quote-modal targets opened by any element
   carrying data-or-quote-modal-open="<target id>" (see the round button in
   open-road-sticky-cta.liquid, style "button" with "opens_modal" on, and the
   modal shell rendered by open-road-enquiry-form.liquid when its
   "render_as_modal" setting is on).

   Namespaced under data-or-quote-modal-* (not data-or-modal-*) on purpose —
   assets/section-open-road-content-modal.css / its section already use the
   data-or-modal-* convention elsewhere in this theme, and this file must
   never intercept those clicks too.

   Accessibility, all required by the brief:
   - role="dialog" + aria-modal="true" + aria-label are on the panel markup.
   - Focus moves into the panel on open, is trapped there (Tab/Shift+Tab
     cycle) while open, and returns to the button that opened it on close.
   - Escape closes. Clicking the backdrop closes (the backdrop element also
     carries data-or-quote-modal-close, so it needs no separate listener). */
(function () {
  'use strict';

  var openModal = null;
  var openTrigger = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusableIn(container) {
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function closeModal() {
    if (!openModal) return;
    var modal = openModal;
    var trigger = openTrigger;
    modal.hidden = true;
    document.body.classList.remove('or-quote-modal-open');
    document.removeEventListener('keydown', onKeydown, true);
    openModal = null;
    openTrigger = null;
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  function onKeydown(e) {
    if (!openModal) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;

    var panel = openModal.querySelector('[data-or-quote-modal-panel]');
    var focusable = focusableIn(panel);
    if (!focusable.length) {
      e.preventDefault();
      if (panel) panel.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    } else if (document.activeElement === document.body || !openModal.contains(document.activeElement)) {
      /* Focus escaped the panel somehow (e.g. it started outside) — pull it back in. */
      e.preventDefault();
      first.focus();
    }
  }

  function openModalById(id, trigger) {
    var modal = id && document.getElementById(id);
    if (!modal || !modal.hasAttribute('data-or-quote-modal')) return;
    if (openModal && openModal !== modal) closeModal();

    openModal = modal;
    openTrigger = trigger || document.activeElement;
    modal.hidden = false;
    document.body.classList.add('or-quote-modal-open');

    var panel = modal.querySelector('[data-or-quote-modal-panel]');
    var focusable = focusableIn(panel);
    (focusable[0] || panel || modal).focus();

    document.addEventListener('keydown', onKeydown, true);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-or-quote-modal-open]');
    if (opener) {
      e.preventDefault();
      openModalById(opener.getAttribute('data-or-quote-modal-open'), opener);
      return;
    }
    if (e.target.closest && e.target.closest('[data-or-quote-modal-close]')) {
      closeModal();
    }
  });
})();
